var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSilicone1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.75,18a.7502.7502,0,0,0-.75-.75H52.75V8h-1.5v9.25H40.75V8h-1.5v9.25H28.75V8h-1.5v9.25H18a.7502.7502,0,0,0-.75.75v9.25H8v1.5h9.25v10.5H8v1.5h9.25v10.5H8v1.5h9.25V62a.7502.7502,0,0,0,.75.75h9.25V72h1.5V62.75h10.5V72h1.5V62.75h10.5V72h1.5V62.75H62a.7502.7502,0,0,0,.75-.75V52.75H72v-1.5H62.75V40.75H72v-1.5H62.75V28.75H72v-1.5H62.75Zm-1.5,43.25H18.75V18.75h42.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25,33.81055V47.25h-2v1.5h5.5v-1.5h-2V32a.74993.74993,0,0,0-1.28027-.53027L36.93945,34,38,35.06055Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSilicone1);
export default __webpack_public_path__ + "static/media/icon_silicone_1.70c2a86625ce2dbca3cc49e7c80fd7b0.svg";
export { ForwardRef as ReactComponent };